import axiosInstance from "@/api/axios-instance";

export async function getForms(params?: {
  region?: string;
  search?: string;
  status?: string;
  limit?: number;
  page?: number;
}) {
  const response = await axiosInstance.get("/forms", { params });
  return response.data;
}
